module.exports = __webpack_public_path__ + "static/img/aRZ_pic01.c6b65b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic01.jpg
// module id = talU
// module chunks = 5